import { __decorate, __extends } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import AddEditCopy from '@/views/assistant/operationsManagement/stroageRule/components/addEditCopy.vue';

var OperationsManagementStorageRuleAddPage = function (_super) {
  __extends(OperationsManagementStorageRuleAddPage, _super);

  function OperationsManagementStorageRuleAddPage() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  OperationsManagementStorageRuleAddPage = __decorate([Component({
    components: {
      AddEditCopy: AddEditCopy
    }
  })], OperationsManagementStorageRuleAddPage);
  return OperationsManagementStorageRuleAddPage;
}(Vue);

export default OperationsManagementStorageRuleAddPage;